import { type useReactFlow } from "@xyflow/react";
import { useSystemStore } from "@/lib/store";

export function focusOnCanvas(
  nodeIds: string[],
  fitView: ReturnType<typeof useReactFlow>["fitView"],
) {
  useSystemStore.getState().setSelection({ nodeIds, cableIds: [] });
  if (nodeIds.length > 0) {
    fitView({
      nodes: nodeIds.map((id) => ({ id })),
      padding: 0.4,
      maxZoom: 1.2,
      minZoom: 0.6,
      duration: 400,
    });
  }
}
